import clsx from 'clsx';
import { checkCellValueStyle, NumericalCellValueStyle } from '@toggle/helpers';
import React from 'react';

import { BAR_HEIGHT, LABEL_WIDTH } from '../constants';

import styles from './Bar.module.scss';

interface BarProps {
  value: number;
  xScale: d3.ScaleLinear<number, number, never>;
  yPosition: number;
}

export const Bar = ({ value, xScale, yPosition }: BarProps) => {
  const numericalStyle = checkCellValueStyle(value);
  const zeroXScale = xScale(0) > 0 ? xScale(0) : 0;
  const xPosition = value < 0 ? xScale(value) : zeroXScale;

  return (
    <rect
      className={clsx({
        [styles.rectPositive]: numericalStyle === NumericalCellValueStyle.Positive,
        [styles.rectNegative]: numericalStyle === NumericalCellValueStyle.Negative,
        [styles.rectNeutral]: numericalStyle === NumericalCellValueStyle.Neutral,
      })}
      data-testid="bar"
      width={Math.abs(xScale(value) - zeroXScale)}
      x={xPosition + LABEL_WIDTH}
      y={yPosition}
      height={BAR_HEIGHT}
    />
  );
};
